/* eslint-disable sonarjs/max-switch-cases */
/* eslint-disable max-lines-per-function */
import {
    Icon20CopyOutline,
    Icon20DeleteOutline,
    Icon20FolderSimpleArrowRightOutlune,
    Icon20InfoCircleOutline,
    Icon20MailOutline,
    Icon20PrinterOutline,
    Icon20WarningTriangleOutline,
    Icon20WriteSquareOutline,
    Icon24ExternalLinkOutline,
} from '@vkontakte/icons';
import Lottie, { type LottieRefCurrentProps } from 'lottie-react';
import React, { type RefObject } from 'react';
import { type MenuItem, MenuItemName } from 'reactApp/ui/ReactViewer/ViewerMenu/MoreMenuButton/MoreMenuButton.types';

import animationFavorite from './animation/favorite.json';
import styles from './MoreMenuButton.css';

export const getDropdownList = (list: MenuItem[], lottieRef: RefObject<LottieRefCurrentProps>) => {
    return list.map(({ name, active, divider, onClick }) => {
        switch (name) {
            case MenuItemName.OPEN_IN_MY:
                return {
                    id: name,
                    divider,
                    text: 'Открыть в моём Облаке',
                    onClick,
                    className: styles.itemWrapper,
                    icon: <Icon24ExternalLinkOutline />,
                };
            case MenuItemName.OPEN_IN_PARENT:
                return {
                    id: name,
                    divider,
                    text: 'Показать в папке',
                    onClick,
                    className: styles.itemWrapper,
                    icon: <Icon24ExternalLinkOutline />,
                };
            case MenuItemName.COPY:
                return {
                    id: name,
                    divider,
                    text: 'Копировать',
                    onClick,
                    className: styles.itemWrapper,
                    icon: <Icon20CopyOutline />,
                };
            case MenuItemName.RENAME:
                return {
                    id: name,
                    divider,
                    text: 'Переименовать',
                    onClick,
                    className: styles.itemWrapper,
                    icon: <Icon20WriteSquareOutline />,
                };
            case MenuItemName.MOVE:
                return {
                    id: name,
                    divider,
                    text: 'Переместить в папку',
                    onClick,
                    className: styles.itemWrapper,
                    icon: <Icon20FolderSimpleArrowRightOutlune />,
                };
            case MenuItemName.MAIL:
                return {
                    id: name,
                    divider,
                    text: 'Отправить по почте',
                    onClick,
                    className: styles.itemWrapper,
                    icon: <Icon20MailOutline />,
                };
            case MenuItemName.FAVORITE:
                return {
                    id: name,
                    divider,
                    text: active ? 'Убрать из избранного' : 'Добавить в избранное',
                    onClick: (file) => {
                        lottieRef?.current?.setDirection(active ? -1 : 1);
                        lottieRef?.current?.play();

                        onClick?.(file);
                    },
                    className: styles.itemWrapper,
                    disableCloseOnClick: true,
                    icon: (
                        <Lottie
                            className={styles.icon}
                            animationData={animationFavorite}
                            autoplay={false}
                            loop={false}
                            lottieRef={lottieRef}
                            onDOMLoaded={() => {
                                if (active) {
                                    lottieRef?.current?.goToAndPlay(60, true);
                                }
                            }}
                        />
                    ),
                };
            case MenuItemName.DELETE:
                return {
                    id: name,
                    divider,
                    text: 'Переместить в корзину',
                    onClick,
                    className: styles.itemWrapper,
                    icon: <Icon20DeleteOutline />,
                };
            case MenuItemName.PRINT:
                return {
                    id: name,
                    divider,
                    text: 'Распечатать',
                    onClick,
                    className: styles.itemWrapper,
                    icon: <Icon20PrinterOutline />,
                };
            case MenuItemName.COMPLAIN:
                return {
                    id: name,
                    divider,
                    text: 'Пожаловаться',
                    onClick,
                    className: styles.itemWrapper,
                    icon: <Icon20WarningTriangleOutline />,
                };
            // tempexp_18663-start
            case MenuItemName.SHOW_PUBLIC_INFO:
                return {
                    id: name,
                    divider,
                    text: 'Посмотреть свойства',
                    onClick,
                    className: styles.itemWrapper,
                    icon: <Icon20InfoCircleOutline />,
                };
            // tempexp_18663-end
        }
    });
};
